"use client";

import React, {useRef} from "react";
import {Box, Button, Container, Paper, Stack, Typography,} from "@mui/material";
import {useSliderProducts} from "@/lib/api";
import CustomSwiper from "@/components/common/slider/custom-swiper";
import FaIcon from "@/components/utilities/fa-icon";
import ProductCardUnified from "@/components/product-card/product-card-unified";
import SliderIcon from "@/app/(pages)/(general)/(home)/components/slider-icon";
import Link from "next/link";

export default function ProductSliderSection({
                                                 title,
                                                 faIcon,
                                                 showAllUrl,
                                                 offer,
                                             }: {
    title: string;
    faIcon: string;
    showAllUrl: string;
    offer: boolean;
}) {
    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const result = useSliderProducts(offer);
    const products: any[] = Array.isArray(result?.data) ? result.data : [];

    const textColor = offer ? "common.white" : "primary.main";
    const bgColor = offer ? "primary.main" : "background.default";
    const contrastColor = offer ? "background.default" : "primary.main";

    return (
        <Box
            position = "relative"
            justifyContent = "space-between"
            py = {2}
            mx = {0}
            bgcolor = {bgColor}
        >
            <Container
                maxWidth = "lg"
                disableGutters = {false}
                sx = {{
                    pr: {xs: "0 !important", md: "24px !important"}
                }}
            >
                <Box
                    pt = {3}
                    px = {{xs: 0, md: 2}}
                    color = {textColor}
                    justifyContent = "space-between"
                    alignItems = "center"
                    display = {{xs: "flex", md: "none"}}
                >
                    <Typography variant = "h5" fontSize = {22} fontWeight = {500} >
                        {title}
                    </Typography >

                    <Button
                        variant = "text"
                        component = {Link}
                        href = {showAllUrl}
                        sx = {{
                            fontSize: 16,
                            fontWeight: 400,
                            p: 0,
                            height: "auto",
                            color: textColor,
                            minWidth: 0,
                            pr: 3.6
                        }}
                    >
                        مشاهده همه
                    </Button >
                </Box >

                <Stack
                    direction = {title === "تازه رسیده‌ها" ? "row-reverse" : "row"}
                    justifyContent = "space-between"
                    alignItems = "stretch"
                >
                    <Paper
                        elevation = {0}
                        sx = {{
                            display: {xs: "none", md: "flex"},
                            width: "15%",
                            bgcolor: bgColor,
                            justifyContent: offer ? "start" : "end",
                        }}
                    >
                        <Box
                            display = "flex"
                            flexDirection = "column"
                            alignItems = "center"
                            justifyContent = "center"
                            height = "100%"
                            color = {contrastColor}
                        >
                            <SliderIcon bgSec = {offer} faIcon = {faIcon} />

                            <Typography variant = "h5" fontSize = {22} >
                                {title}
                            </Typography >
                            <Button
                                component = {Link}
                                href = {showAllUrl}
                                variant = "text"
                                sx = {{my: .5, mb: 2, color: contrastColor}}
                            >
                                مشاهده همه
                            </Button >

                            <Box display = "flex" >
                                <Button
                                    ref = {prevRef}
                                    variant = "outlined"
                                    sx = {{
                                        minWidth: 0,
                                        width: 42,
                                        height: 42,
                                        mr: 1,
                                        borderColor: contrastColor,
                                        "&:hover": {borderColor: "grey.500"},
                                        "&.Mui-disabled": {opacity: 0.5},
                                        "&:disabled": {opacity: 0.5},
                                    }}
                                >
                                    <FaIcon faIcon = "fa-arrow-right" fontSize = {24}
                                        sx = {{color: contrastColor}} />
                                </Button >

                                <Button
                                    ref = {nextRef}
                                    variant = "outlined"
                                    sx = {{
                                        minWidth: 0,
                                        width: 42,
                                        height: 42,
                                        ml: 1,
                                        borderColor: contrastColor,
                                        "&:hover": {borderColor: "grey.500"},
                                        "&.Mui-disabled": {opacity: 0.5},
                                        "&:disabled": {opacity: 0.5},
                                    }}
                                >
                                    <FaIcon faIcon = "fa-arrow-left" fontSize = {24}
                                        sx = {{color: contrastColor}} />
                                </Button >
                            </Box >

                        </Box >

                    </Paper >

                    <Box width = {{xs: "100%", md: "85%"}} >
                        <CustomSwiper
                            items={products?.map((item, idx) => (
                                <ProductCardUnified
                                    key={idx}
                                    offer={offer}
                                    productData={item}
                                    variant="grid"
                                    slider
                                />
                            ))}
                            slideMinWidth={255}
                            slideMaxWidth={310}
                            slideFluidWidth="50vw"
                            auto={false}
                            clickable={false}
                            navigation={true}
                            prevRef={prevRef}
                            nextRef={nextRef}
                            offset
                            loop={false}
                            mode="auto"
                        />

                    </Box >
                </Stack >
            </Container >

        </Box >
    );
}


